import Link from 'redux-first-router-link'
import { Tooltip } from 'shared/ui'

export default function BackButton({ to }) {
  return (
    <div key="back-button" className="back">
      <Tooltip position="bottom" tooltip={'Back'}>
        <Link className="menu-button" to={to}>
          <span className="Icon Icon-arrow-back" />
        </Link>
      </Tooltip>
    </div>
  )
}
